// extracted by mini-css-extract-plugin
export var addToCartButton = "_n7-b";
export var arrowButtonContainer = "_n7-9";
export var arrowButtonIcon = "_n7-a";
export var carouselArrowButton = "_n7-6";
export var carouselElementContainer = "_n7-1";
export var left = "_n7-7";
export var productDisplayCarouselContainer = "_n7-0";
export var productTileContainer = "_n7-2";
export var productTileImage = "_n7-4";
export var productTileImageContainer = "_n7-3";
export var productTileTitle = "_n7-5";
export var right = "_n7-8";
export var sliderOverflow = "_n7-c";